import React, { useState } from "react"
import { Link } from "gatsby"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import Dropdown from "react-bootstrap/Dropdown"
import "./style.scss"
import { IoIosArrowDown } from "react-icons/io"
import RequestDemo from "../modals/requestdemo/RequestDemo"
import { useLocation } from "@reach/router"
import _ from "lodash"

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <p
    className="nav-link list"
    ref={ref}
    onClick={e => {
      e.preventDefault()
      onClick(e)
    }}
  >
    {children}
  </p>
))
const AppNav = ({ withBrand, fixed, slidePosition, btnBg, btnColor }) => {
  console.log('banner', fixed)
  const [showDemoModal, setShowDemoModal] = useState(false)
  const [navExpanded, setExpanded] = useState(false)
  // const [showProductsDropdown, setShowProductsDropdown] = useState(false)
  // const [showResourcesDropdown, setShowResourcesDropdown] = useState(false)

  const showModal = () => {
    setShowDemoModal(!showDemoModal)
  }
  const collapseNav = expanded => {
    setExpanded(expanded)
  }
  let location = useLocation()
  return (
    <>
    <div className="desktop">
    <Navbar
      fixed={fixed}
      expand="lg"
      onToggle={collapseNav}
      className={`${slidePosition === 1 ? "white" : ""} ${
        navExpanded ? "collapsed" : ""
      }`}
    >
      {showDemoModal && <RequestDemo show={showDemoModal} onHide={showModal} />}
      <div>
      <div style={{ display: 'flex' }}>
      <Navbar.Brand href="/" className="logoLink">
        {!withBrand && <h1 className="logo">wersel</h1>}
        {withBrand && (
          <img
            className={`app-logo${slidePosition === 1 ? "-white" : ""}`}
            alt="logo"
            style={{ maxWidth: '90%' }}
          />
        )}
      </Navbar.Brand>
      {_.isEqual(fixed,'top') ?
      <Navbar.Toggle
        className="custom-top-toggler navbar-top-toggler"
        aria-controls="basic-navbar-nav"
      >
        <span className="navbar-toggler-icon"></span>
      </Navbar.Toggle> : 
      <Navbar.Toggle
      className="custom-toggler navbar-toggler"
      aria-controls="basic-navbar-nav"
    >
      <span className="navbar-toggler-icon"></span>
    </Navbar.Toggle>
      }
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto navbar-right text-center">
          <li className={`${fixed === 'top' ? "nav-white-item" : "nav-item"}`}>
            <Link activeClassName="active" to="/our-story" className={`${fixed === 'top' ? "nav-white-link" : "nav-link"}`}>
              Our Story<span className="sr-only">(current)</span>
            </Link>
          </li>
          {/* <li
            className="nav-item"
            // onMouseEnter={() => setShowProductsDropdown(true)}
            // onMouseLeave={() => setShowProductsDropdown(false)}
          >
            <Dropdown>
              <Dropdown.Toggle
                as={CustomToggle}
                id="dropdown-custom-components"
              >
                <span>
                  Products&nbsp;
                  <IoIosArrowDown />
                </span>
                <span className="lower">
                  <hr className="border-bottom" />
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="/products/glassx/" eventKey="1">
                  Collaboration Platform
                </Dropdown.Item>
                <Dropdown.Item href="/products/pricex/" eventKey="2">
                  Pricing Intelligence Platform
                </Dropdown.Item>
                <Dropdown.Item href="/products/discoverx/" eventKey="3">
                  Enterprise Search Platform
                </Dropdown.Item>
                <Dropdown.Item href="/products/dashx/" eventKey="4">
                  Business Intelligence Platform
                </Dropdown.Item>
                <Dropdown.Item href="/products/scoopx/" eventKey="5">
                  AI-Powered Product Data Platform
                </Dropdown.Item>
                <Dropdown.Item href="/products/counterfeitx/" eventKey="6">
                  AI-Powered Anti Counterfeit Tool
                </Dropdown.Item>
                <Dropdown.Item href="/products/prex/" eventKey="7">
                  Personalized Product Recommendations Engine
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li> */}
          {/* <li className="nav-item">
            <Dropdown>
              <Dropdown.Toggle
                as={CustomToggle}
                id="dropdown-custom-components"
              >
                <span>
                  Solutions&nbsp;
                  <IoIosArrowDown />
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  href="/solutions/mobile-app-development-london/"
                  eventKey="1"
                >
                  Mobile App Development
                </Dropdown.Item>
                <Dropdown.Item
                  href="/solutions/animated-video-production/"
                  eventKey="1"
                >
                  Animated Explanatory Videos
                </Dropdown.Item>
                <Dropdown.Item
                  href="/solutions/wersel-product-page-optimization/"
                  eventKey="1"
                >
                  A+ Page Development
                </Dropdown.Item>
                <Dropdown.Item href="/solutions/data-as-service/" eventKey="1">
                  Data As A Service
                </Dropdown.Item>
                <Dropdown.Item
                  href="/solutions/data-visualization/"
                  eventKey="1"
                >
                  Data Visualization Service
                </Dropdown.Item>
                <Dropdown.Item href="/solutions/brand-protection/" eventKey="1">
                  Brand Protection Service
                </Dropdown.Item>
                <Dropdown.Item
                  href="/solutions/marketplace-monitoring/"
                  eventKey="1"
                >
                  Marketplace Monitoring Service
                </Dropdown.Item>
                <Dropdown.Item href="/solutions/web-scraping/" eventKey="1">
                  Web Scraping Services
                </Dropdown.Item>
                <Dropdown.Item
                  href="/solutions/data-advisory-service/"
                  eventKey="1"
                >
                  Data Advisory Services
                </Dropdown.Item>
                <Dropdown.Item
                  href="/solutions/data-analytics-solutions"
                  eventKey="1"
                >
                  Data Analytics Solutions
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li> */}
          {/* <li className="nav-item">
            <Link to="#" className="nav-link">
              Pricing
            </Link>
          </li> */}
          <li className="nav-item">
            <Dropdown>
              <Dropdown.Toggle
                as={CustomToggle}
                id="dropdown-custom-components"
              >
                <span className={`${fixed === 'top' ? "nav-white-color-link" : "nav-color-link"}`}>
                  Features
                  <IoIosArrowDown />
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  href="/people-AI-analytics/"
                  eventKey="1"
                >
                  People & AI Analytics
                </Dropdown.Item>
                <Dropdown.Item
                  href="/data-management/"
                  eventKey="2"
                >
                  Data Management
                </Dropdown.Item>
                <Dropdown.Item
                  href="/flexible-collaboration/"
                  eventKey="3"
                >
                  Flexible Collaboration
                </Dropdown.Item>
                <Dropdown.Item
                  href="/enterprise-search/"
                  eventKey="4"
                >
                  Enterprise Search
                </Dropdown.Item>
                <Dropdown.Item
                  href="/learn-with-wersel/"
                  eventKey="4"
                >
                  Learn with Wersel
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li>
          <li className={`${fixed === 'top' ? "nav-white-item" : "nav-item"}`}>
            <Link activeClassName="active" to="/#benefits" className={`${fixed === 'top' ? "nav-white-link" : "nav-link"}`}>
              Benefits
            </Link>
          </li>
          {/* <li className="nav-item">
            <Dropdown>
              <Dropdown.Toggle
                as={CustomToggle}
                id="dropdown-custom-components"
              >
                <span>
                  Benefits&nbsp;
                  <IoIosArrowDown />
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  href="/"
                  eventKey="1"
                >
                  Circle of Trust
                </Dropdown.Item>
                <Dropdown.Item
                  href="/"
                  eventKey="2"
                >
                  Value Proposition
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li> */}
          <li
            className="nav-item"
            // onMouseEnter={() => setShowResourcesDropdown(true)}
            // onMouseLeave={() => setShowResourcesDropdown(false)}
          >
            <Dropdown>
              <Dropdown.Toggle
                as={CustomToggle}
                id="dropdown-custom-components"
              >
                <span className={`${fixed === 'top' ? "nav-white-color-link" : "nav-color-link"}`}>
                  {" "}
                  Resources
                  <IoIosArrowDown />
                </span>
                {/* <span className="lower">
                  <hr className="border-bottom" />
                </span> */}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/blogs" eventKey="1">
                  Blogs
                </Dropdown.Item>
                <Dropdown.Item href="/ebooks" eventKey="2">
                  Ebooks
                </Dropdown.Item>
                <Dropdown.Item href="/videos" eventKey="3">
                  Videos
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li>
          {location.pathname === "/" && (
            <li className={`${fixed === 'top' ? "nav-white-item-client" : "nav-item"}`}>
              <Link activeClassName="active" to="/#clients" className={`${fixed === 'top' ? "nav-white-link" : "nav-link"}`}>
                Clients
              </Link>
            </li>
          )}
          {location.pathname.split("/").includes("products") && (
            <li className={`${fixed === 'top' ? "nav-white-item-client" : "nav-item"}`}>
              <Link activeClassName="active" to="/#clients" className={`${fixed === 'top' ? "nav-white-link" : "nav-link"}`}>
                Clients
              </Link>
            </li>
          )}

          <li className={`${fixed === 'top' ? "nav-white-item" : "nav-item"}`}>
            <Link activeClassName="active" to="/careers" className={`${fixed === 'top' ? "nav-white-link" : "nav-link"}`}>
              Careers
            </Link>
          </li>
          <li className="nav-item" style={{ display: 'flex', justifyContent: 'center', paddingBottom: '2px' }}>
            <Link to="https://wersel.world/learn/" className="request_demo_link">
              <div
                style={{
                  background: btnBg ? btnBg : "",
                  color: btnColor ? btnColor : "",
                }}
                className="request__demo"
                // onClick={showModal}
              >
                Course Registration
              </div>
            </Link>
          </li>
        </Nav>
      </Navbar.Collapse>
      </div>
      <div className="HeaderLine"></div>
      </div>
    </Navbar>
    </div>



    <div className="mobile">
    <Navbar
      fixed={fixed}
      expand="lg"
      onToggle={collapseNav}
      className={`${slidePosition === 1 ? "white" : ""} ${
        navExpanded ? "collapsed" : ""
      }`}
    >
      {showDemoModal && <RequestDemo show={showDemoModal} onHide={showModal} />}
      <Navbar.Brand href="/" className="logoLink">
        {!withBrand && <h1 className="logo">wersel</h1>}
        {withBrand && (
          <img
            className={`app-logo${slidePosition === 1 ? "-white" : ""}`}
            alt="logo"
            style={{ maxWidth: '90%' }}
          />
        )}
      </Navbar.Brand>
      <Navbar.Toggle
        className="custom-toggler navbar-toggler"
        aria-controls="basic-navbar-nav"
      >
        <span className="navbar-toggler-icon"></span>
      </Navbar.Toggle>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto navbar-right text-center">
          <li className="nav-item">
            <Link activeClassName="active" to="/our-story" className="nav-link">
              Our Story<span className="sr-only">(current)</span>
            </Link>
          </li>
          {/* <li
            className="nav-item"
            // onMouseEnter={() => setShowProductsDropdown(true)}
            // onMouseLeave={() => setShowProductsDropdown(false)}
          >
            <Dropdown>
              <Dropdown.Toggle
                as={CustomToggle}
                id="dropdown-custom-components"
              >
                <span>
                  Products&nbsp;
                  <IoIosArrowDown />
                </span>
                <span className="lower">
                  <hr className="border-bottom" />
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="/products/glassx/" eventKey="1">
                  Collaboration Platform
                </Dropdown.Item>
                <Dropdown.Item href="/products/pricex/" eventKey="2">
                  Pricing Intelligence Platform
                </Dropdown.Item>
                <Dropdown.Item href="/products/discoverx/" eventKey="3">
                  Enterprise Search Platform
                </Dropdown.Item>
                <Dropdown.Item href="/products/dashx/" eventKey="4">
                  Business Intelligence Platform
                </Dropdown.Item>
                <Dropdown.Item href="/products/scoopx/" eventKey="5">
                  AI-Powered Product Data Platform
                </Dropdown.Item>
                <Dropdown.Item href="/products/counterfeitx/" eventKey="6">
                  AI-Powered Anti Counterfeit Tool
                </Dropdown.Item>
                <Dropdown.Item href="/products/prex/" eventKey="7">
                  Personalized Product Recommendations Engine
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li> */}
          {/* <li className="nav-item">
            <Dropdown>
              <Dropdown.Toggle
                as={CustomToggle}
                id="dropdown-custom-components"
              >
                <span>
                  Solutions&nbsp;
                  <IoIosArrowDown />
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  href="/solutions/mobile-app-development-london/"
                  eventKey="1"
                >
                  Mobile App Development
                </Dropdown.Item>
                <Dropdown.Item
                  href="/solutions/animated-video-production/"
                  eventKey="1"
                >
                  Animated Explanatory Videos
                </Dropdown.Item>
                <Dropdown.Item
                  href="/solutions/wersel-product-page-optimization/"
                  eventKey="1"
                >
                  A+ Page Development
                </Dropdown.Item>
                <Dropdown.Item href="/solutions/data-as-service/" eventKey="1">
                  Data As A Service
                </Dropdown.Item>
                <Dropdown.Item
                  href="/solutions/data-visualization/"
                  eventKey="1"
                >
                  Data Visualization Service
                </Dropdown.Item>
                <Dropdown.Item href="/solutions/brand-protection/" eventKey="1">
                  Brand Protection Service
                </Dropdown.Item>
                <Dropdown.Item
                  href="/solutions/marketplace-monitoring/"
                  eventKey="1"
                >
                  Marketplace Monitoring Service
                </Dropdown.Item>
                <Dropdown.Item href="/solutions/web-scraping/" eventKey="1">
                  Web Scraping Services
                </Dropdown.Item>
                <Dropdown.Item
                  href="/solutions/data-advisory-service/"
                  eventKey="1"
                >
                  Data Advisory Services
                </Dropdown.Item>
                <Dropdown.Item
                  href="/solutions/data-analytics-solutions"
                  eventKey="1"
                >
                  Data Analytics Solutions
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li> */}
          {/* <li className="nav-item">
            <Link to="#" className="nav-link">
              Pricing
            </Link>
          </li> */}
          <li className="nav-item">
            <Dropdown>
              <Dropdown.Toggle
                as={CustomToggle}
                id="dropdown-custom-components"
              >
                <span>
                  Features
                  <IoIosArrowDown />
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  href="/people-AI-analytics/"
                  eventKey="1"
                >
                  People & AI Analytics
                </Dropdown.Item>
                <Dropdown.Item
                  href="/data-management/"
                  eventKey="2"
                >
                  Data Management
                </Dropdown.Item>
                <Dropdown.Item
                  href="/flexible-collaboration/"
                  eventKey="3"
                >
                  Flexible Collaboration
                </Dropdown.Item>
                <Dropdown.Item
                  href="/enterprise-search/"
                  eventKey="4"
                >
                  Enterprise Search
                </Dropdown.Item>
                <Dropdown.Item
                  href="/learn-with-wersel/"
                  eventKey="4"
                >
                  Learn with Wersel
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li>
          <li className="nav-item">
            <Link activeClassName="active" to="/#benefits" className="nav-link">
              Benefits
            </Link>
          </li>
          {/* <li className="nav-item">
            <Dropdown>
              <Dropdown.Toggle
                as={CustomToggle}
                id="dropdown-custom-components"
              >
                <span>
                  Benefits&nbsp;
                  <IoIosArrowDown />
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  href="/"
                  eventKey="1"
                >
                  Circle of Trust
                </Dropdown.Item>
                <Dropdown.Item
                  href="/"
                  eventKey="2"
                >
                  Value Proposition
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li> */}
          <li
            className="nav-item"
            // onMouseEnter={() => setShowResourcesDropdown(true)}
            // onMouseLeave={() => setShowResourcesDropdown(false)}
          >
            <Dropdown>
              <Dropdown.Toggle
                as={CustomToggle}
                id="dropdown-custom-components"
              >
                <span>
                  {" "}
                  Resources
                  <IoIosArrowDown />
                </span>
                {/* <span className="lower">
                  <hr className="border-bottom" />
                </span> */}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/blogs" eventKey="1">
                  Blogs
                </Dropdown.Item>
                <Dropdown.Item href="/ebooks" eventKey="2">
                  Ebooks
                </Dropdown.Item>
                <Dropdown.Item href="/videos" eventKey="3">
                  Videos
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li>
          {location.pathname === "/" && (
            <li className="nav-item">
              <Link activeClassName="active" to="/#clients" className="nav-link">
                Clients
              </Link>
            </li>
          )}
          {location.pathname.split("/").includes("products") && (
            <li className="nav-item">
              <Link activeClassName="active" to="/#clients" className="nav-link">
                Clients
              </Link>
            </li>
          )}

          <li className="nav-item">
            <Link activeClassName="active" to="/careers" className="nav-link">
              Careers
            </Link>
          </li>
          <li className="nav-item" style={{ display: 'flex', justifyContent: 'center', paddingBottom: '2px' }}>
            <Link to="https://wersel.world/learn/" className="request_demo_link">
              <div
                style={{
                  background: btnBg ? btnBg : "",
                  color: btnColor ? btnColor : "",
                }}
                className="request__demo"
                // onClick={showModal}
              >
                Course Registration
              </div>
            </Link>
          </li>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
    </div>
    </>
  )
}
export default AppNav
